import React from 'react';

const Fabworks: React.FC = () => {
  const galleryImages = [
    {
      imagePath: "/gallery/sandstorm.jpg",
      altText: "-",
      title: "Bent aluminum ears and internal structures for Sandstorm"
    },
    {
      imagePath: "/gallery/impact.jpg",
      altText: "-",
      title: "Superstructure shell on IMPACT"
    },
    {
      imagePath: "/gallery/rollout.jpg",
      altText: "-",
      title: "Rollout frame, wedgelets, and arm"
    },
    {
      imagePath: "/gallery/arena.jpg",
      altText: "-",
      title: "Combat robot test arena"
    }
  ];

  return (
    <div className="min-h-screen bg-transparent p-0 relative bg-gray-900">
        <div className="max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl mx-auto p-8 md:p-12 lg:p-16 py-16 flex flex-col justify-start relative">
          
          {/* Header Section */}
          <div className="text-center mb-8 animate-fadeInUp">
            <div className="mb-6 flex justify-center">
              <img 
                src="/fabworks.png" 
                className="w-32 h-32 transition-all duration-300 object-contain"
              />
            </div>
            
            <p className="text-lg md:text-xl text-gray-300 mb-6 font-medium">
              Level 5 Robotics is is a proud member of #TeamFabworks
            </p>
            <div className="bg-gradient-to-r from-yellow-500/20 to-orange-500/20 border border-yellow-500/30 rounded-xl p-6 backdrop-blur-sm">
              <h2 className="text-xl font-semibold text-yellow-400 mb-3">Use Code: LEVEL5</h2>
              <p className="text-2xl font-bold text-white mb-2">5% OFF</p>
              <p className="text-sm text-gray-300">All sheet metal fabrication and tube laser cutting services</p>
            </div>
          </div>

          {/* Sponsor Blurb Section */}
          <div className="my-12 md:my-16">
            <h3 className="text-lg md:text-xl font-semibold text-gray-300 mb-6 text-center tracking-wide relative">
              About Fabworks
              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-10 h-0.5 bg-gradient-to-r from-transparent via-yellow-500/60 to-transparent"></div>
            </h3>
            <div className="bg-gray-800/90 border border-yellow-500/20 rounded-xl p-6 md:p-8 backdrop-blur-sm">
              <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-4">
                Fabworks is an industry leader in rapid sheet metal fabrication services. Their fully automated quoting platform makes it dead simple to upload your parts and get quotes instantly. Their streamlined facilities and rockstar team get parts to you in a matter of days, not weeks. 
              </p>
              <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-4">
                Level 5 Robotics trusts Fabworks to deliver high quality sheet and tube components for our combat robots, Rival Robots, personal projects, and the various FIRST Robotics teams that we support. 
              </p>
            </div>
          </div>

          {/* Gallery Section */}
          <div className="my-12 md:my-16">
            <h3 className="text-lg md:text-xl font-semibold text-gray-300 mb-6 text-center tracking-wide relative">
              Projects powered by Fabworks.
              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-10 h-0.5 bg-gradient-to-r from-transparent via-yellow-500/60 to-transparent"></div>
            </h3>
            <div className="grid grid-cols-2 gap-4 max-w-full">
              {galleryImages.map((image, index) => (
                <div
                  key={index}
                  className="block relative overflow-hidden rounded-xl transition-all duration-300 aspect-square bg-gray-800/90 border border-yellow-500/20 hover:-translate-y-1 hover:shadow-lg hover:border-yellow-500/60 focus:outline-none focus:ring-2 focus:ring-yellow-500/80 focus:ring-offset-2"
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent z-10"></div>
                  <img 
                    src={image.imagePath} 
                    alt={image.altText}
                    loading="lazy"
                    className="w-full h-full object-cover transition-all duration-300 hover:scale-105"
                  />
                  <div className="absolute bottom-0 left-0 right-0 p-3 z-20">
                    <p className="text-sm font-semibold text-white">{image.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Section */}
          <div className="my-12 md:my-16">
            <div className="bg-gradient-to-r from-yellow-500/10 to-orange-500/10 border border-yellow-500/30 rounded-xl p-6 md:p-8 text-center backdrop-blur-sm">
              <h3 className="text-xl md:text-2xl font-bold text-yellow-400 mb-4">
                Ready to Build Your Champion Robot?
              </h3>
              <p className="text-gray-300 mb-6">
                Get professional laser cutting for your robot parts today with our discount code.
              </p>
              <a 
                href="https://fabworks.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-yellow-500 to-orange-500 text-white font-semibold rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-yellow-500/30 focus:outline-none focus:ring-2 focus:ring-yellow-500/80 focus:ring-offset-2"
              >
                Visit Fabworks
                <span className="ml-2">→</span>
              </a>
              <p className="text-sm text-gray-400 mt-4">
                Don't forget to use code <span className="font-semibold text-yellow-400">LEVEL5</span> for 5% off!
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="text-center mt-auto pt-8 border-t border-gray-600/30">
            <a 
              href="/" 
              className="text-gray-400 hover:text-white transition-colors duration-300"
            >
              ← Back to Level 5 Robotics
            </a>
          </div>
                 </div>
       </div>
   );
 };

export default Fabworks; 